























import BankCodeSelectionPopup from '@/components/popup/btt/BankCodeSelection.vue'
import BankAccountFormPopup from '@/components/popup/btt/BankAccountForm.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import PopupHandlerMixin from '@/mixins/popupHandler'

const banks = namespace('banks')

@Component({
  components: {
    BankCodeSelectionPopup,
    BankAccountFormPopup
  },
})

export default class BankCreatePopups extends Mixins(PopupHandlerMixin) {
  @banks.Mutation('updateOwner') updateOwner
  @banks.Mutation('updateBankCode') updateBankCode

  @Prop({default: false, type: Boolean}) isOpen: boolean

  @Watch('isOpen', {immediate: true})
  __isOpen(value) {
    this.setPopupStatus('bankCodeSelection', value)
  }

  openBankCreation(code) {
    this.updateBankCode(code)
    this.openPopup('bankAccountForm')
  }

  onCloseAccountForm() {
    this.closePopup('bankAccountForm')
    this.$emit('close')
  }

  close(value) {
    this.setPopupStatus('bankCodeSelection', value)
    this.$emit('close')
  }
}
